import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // ← initialises i18next + loads all 7 language packs (EN + 6).
import AppRouter from "@/AppRouter";
import { announceBuild } from "@/buildInfo";

announceBuild();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
);
